import { type RefObject, useEffect } from 'react';

export const useClickOutside = (
    insideRefs: RefObject<HTMLElement>[],
    onClickOutside: () => void,
    isOpen: boolean = true,
) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (insideRefs.every((ref) => !ref?.current?.contains(event.target as Node))) {
                onClickOutside();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [insideRefs, isOpen, onClickOutside]);
};
